export const FORMATS_ROUTING = [
  {
    path: '/format/:format',
    name: 'format',
    component: () =>
      import(/* webpackChunkName: "format-page" */ './pages/format/format.page'),
    alias: []
  }
];
